import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";

const MODAL_BASE_Z_INDEX = 1050;
const MODAL_Z_INDEX_STEP = 10;

export const ModalStackContext = createContext({
    zIndex: MODAL_BASE_Z_INDEX,
    backdropZIndex: MODAL_BASE_Z_INDEX - 1
});

export const useModalStackContext = () => useContext(ModalStackContext);

let modalIdCounter = 0;
const openedModalIds = [];

const getModalLevel = (modalId) => {
    const index = openedModalIds.indexOf(modalId);
    return index === -1 ? openedModalIds.length : index;
};

const addModal = (modalId) => {
    if (!openedModalIds.includes(modalId)) {
        openedModalIds.push(modalId);
    }
};

const removeModal = (modalId) => {
    const index = openedModalIds.indexOf(modalId);

    if (index !== -1) {
        openedModalIds.splice(index, 1);
    }
};

export const useModalStack = (open) => {
    const modalIdRef = useRef(null);
    const [level, setLevel] = useState(0);

    if (modalIdRef.current === null) {
        modalIdCounter += 1;
        modalIdRef.current = modalIdCounter;
    }

    useEffect(() => {
        const modalId = modalIdRef.current;

        if (!open) {
            removeModal(modalId);
            return undefined;
        }

        addModal(modalId);
        setLevel(getModalLevel(modalId));

        return () => {
            removeModal(modalId);
        };
    }, [open]);

    return useMemo(() => {
        const zIndex = MODAL_BASE_Z_INDEX + level * MODAL_Z_INDEX_STEP;

        return {
            zIndex,
            backdropZIndex: zIndex - 1
        };
    }, [level]);
};
